import * as type from './types';

export function getProfileData(data) {
    return {
        type: type.GET_PROFILE_DATA_REQUESTED,
        data: data,
    }
}